import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_DM_PROFILE_REDESIGN = createFcmDetails('dm_profile_redesign', {
	owner: 'Capybara',
	context: 'New DM Profile Page Design',
	description: 'Feature release flag that enables visibility of redesign by component',
	import: false,
	template: {
		profileCard: false,
		targetedPetitionList: false,
		sapToDm: false,
		responseList: false,
		responsivenessScore: false,
	},
	mergeLogic:
		"Requires both `locale` and `countryCode` values to be `true` for each component's redesign to be enabled",
});
